module.exports = __webpack_public_path__ + "img/icon_rubric_setting.eeab2e21.svg";